module.exports = __webpack_public_path__ + "img/share-facebook.d0b07c9b.svg";